import React, {Component} from 'react';
import {FeatureFlag} from 'react-launch-darkly';

export default class BusinessEmail extends Component {
    static defaultProps = {
        placeholder: 'Email'
    };

    constructor(props) {
        super(props);

        this.state = {
            email: props.email
        };
    }

    render() {
        const {placeholder} = this.props;
        const {email} = this.state;

        return (
            <div className="form-group">
                <input
                    className="form-control"
                    placeholder={placeholder}
                    type="text"
                    name="email"
                    id="email"
                    value={email}
                    onChange={event =>
                        this.setState({
                            email: event.target.value ? event.target.value : null
                        })
                    }
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./brand/business_email.js